// Visual Free Gift Display Logic - Cart Drawer Only
// Lightweight version without global fetch/XHR interception

window.VisualFreeGift = window.VisualFreeGift || (function() {
  const FREE_GIFT_THRESHOLD = 89900; // ₹899 in paise (will be overridden by Liquid)
  let isInitialized = false;

  function updateVisualFreeGift() {
    const freeGiftCard = document.getElementById('visual-free-gift-card');
    if (!freeGiftCard) {
      return;
    }

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const threshold = window.FREE_GIFT_THRESHOLD || FREE_GIFT_THRESHOLD;

        if (cart.total_price >= threshold) {
          freeGiftCard.classList.add('show');
        } else {
          freeGiftCard.classList.remove('show');
        }
      })
      .catch(error => console.error('Free gift update error:', error));
  }

  function init() {
    if (isInitialized) {
      return;
    }
    isInitialized = true;

    // Initial update
    updateVisualFreeGift();
  }

  // Public API
  return {
    init: init,
    update: updateVisualFreeGift
  };
})();
